import {createReducer, on} from '@ngrx/store';
import {CollectionState} from '../collection.model';
import * as CollectionActions from './collection.actions';

export const collectionFeatureKey = 'collection';

export const initialState: CollectionState = {
  loading: false,
  data: {
    id: null,
    collectionItems: [],
  },
  scan: {
    loading: false,
    code: undefined,
    result: undefined,
    permission: 'prompt'
  },
  selectedTabIndex: 0
};

export const collectionReducer = createReducer(
  initialState,
  on(CollectionActions.loadCollection, (state, {loading}) => ({
    ...state,
    loading
  })),
  on(CollectionActions.loadCollectionSuccess, (state, {collection}) => {
    if (!collection) {
      return {...state, loading: false};
    }
    return {
      ...state,
      data: {
        id: collection.id,
        collectionItems: collection?.collectionItems ?? []
      },
      loading: false
    };
  }), on(CollectionActions.loadCollectionError, (state) => ({
    ...state,
    data: {
      id: null,
      collectionItems: []
    },
    loading: false
  })),

  on(CollectionActions.createCollectionError, (state) => ({
    ...state,
    data: {id: null, name: '', collectionItems: [], news: []}
  })),

  on(CollectionActions.barcodeCheckSuccess, (state, {collectionItem}) => {
    return {
      ...state,
      scan: {
        ...state.scan,
        result: collectionItem
      }
    };
  }),


  on(CollectionActions.barcodeCheckError, (state) => ({
    ...state,
    scan: {
      ...state.scan,
      result: undefined
    }
  })),

  on(CollectionActions.barcodeCheckRemove, (state) => {
    return state;
  }),


  on(CollectionActions.barcodeCheckAddToCollection, (state) => {
    if (!state.scan?.result || !state.data) return state;

    return {
      ...state,
      data: {
        ...state.data,
        collectionItems: [...(state.data.collectionItems ?? []), {...state.scan.result}]
      }
    };
  }),
  on(CollectionActions.setSelectedTabIndex, (state, { index }) => ({
    ...state,
    selectedTabIndex: index
  }))
)
